import { DefaultTreeAdapterMap, parseFragment } from 'parse5';

export default function removeScripts(contentHtml: string): string {
  const fragment = parseFragment(contentHtml, { sourceCodeLocationInfo: true });
  const locations: Array<{ startOffset: number; endOffset: number }> = [];
  const collectScripts = (node: DefaultTreeAdapterMap['node']): void => {
    if ('tagName' in node && node.tagName === 'script' && node.sourceCodeLocation) {
      const { startOffset, endOffset } = node.sourceCodeLocation;
      locations.push({
        startOffset,
        endOffset: endOffset > startOffset ? endOffset : contentHtml.length
      });
    } else {
      if ('childNodes' in node) {
        node.childNodes.forEach(collectScripts);
      }
      if ('content' in node) {
        collectScripts(node.content);
      }
    }
  };
  collectScripts(fragment);

  // Remove source ranges so unrelated markup and raw-text contents stay intact.
  return locations
    .sort((first, second) => second.startOffset - first.startOffset)
    .reduce(
      (html, { startOffset, endOffset }) => html.slice(0, startOffset) + html.slice(endOffset),
      contentHtml
    );
}
